export default "__VITE_ASSET__D582CzHy__"